var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.3333L14.6667 18L20.6667 12M26.6667 16C26.6667 22.5446 19.5281 27.3045 16.9307 28.8198C16.6355 28.992 16.4879 29.0782 16.2796 29.1228C16.1179 29.1575 15.8821 29.1575 15.7204 29.1228C15.5121 29.0782 15.3645 28.992 15.0693 28.8198C12.4719 27.3045 5.33333 22.5446 5.33333 16V9.62347C5.33333 8.55745 5.33333 8.02444 5.50768 7.56627C5.6617 7.16152 5.91198 6.80037 6.23688 6.51404C6.60466 6.18992 7.10373 6.00277 8.10187 5.62846L15.2509 2.94757C15.5281 2.84362 15.6667 2.79164 15.8093 2.77104C15.9358 2.75277 16.0642 2.75277 16.1907 2.77104C16.3333 2.79164 16.4719 2.84362 16.7491 2.94757L23.8981 5.62846C24.8963 6.00277 25.3953 6.18992 25.7631 6.51404C26.088 6.80037 26.3383 7.16152 26.4923 7.56627C26.6667 8.02444 26.6667 8.55745 26.6667 9.62347V16Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldTick);
export default __webpack_public_path__ + "static/media/shield-tick.bdd5d257b5a065c87ac57b03df1033a2.svg";
export { ForwardRef as ReactComponent };